import React from 'react';
interface TCPAConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}
export function TCPAConsent({
  checked,
  onChange,
  error
}: TCPAConsentProps) {
  return <div className="mt-4 mb-6" data-id="element-525">
      <div className="flex items-start" data-id="element-526">
        <div className="flex items-center h-5" data-id="element-527">
          <input id="tcpa-consent" name="tcpa-consent" type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} className="focus:ring-navy h-4 w-4 text-crimson border-gray-300 rounded cursor-pointer" data-id="element-528" />
        </div>
        <div className="ml-3 text-xs text-gray-500 leading-tight" data-id="element-529">
          <label htmlFor="tcpa-consent" className="cursor-pointer" data-id="element-530">
            By checking this box, I consent to receive emails, phone calls, and
            SMS text messages from OnlineCollegeGuide and its partner schools at
            the email and phone number provided, including my wireless number if
            provided. I understand these calls may be generated using an
            automated technology. I understand that my consent is not required
            to use this service or to enroll in a program.
          </label>
        </div>
      </div>
      {error && <p className="mt-2 text-sm text-red-600" data-id="element-531">{error}</p>}
    </div>;
}